import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminLogin } from '../../lib/api';
import { Lock } from 'lucide-react';

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('gestion@imargo.be');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('imodeff_admin_token')) nav('/admin', { replace: true });
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await adminLogin(email.trim().toLowerCase(), password);
      localStorage.setItem('imodeff_admin_token', token);
      nav('/admin', { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = 'w-full bg-transparent border-b border-neutral-300 focus:border-black outline-none py-3 text-[15px] transition-colors';

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white shadow-sm p-10">
        <Link to="/" className="inline-flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-neutral-500 hover:text-black">
          ← Back to imodeff.com
        </Link>
        <div className="mt-8 flex items-center gap-3">
          <span className="w-8 h-8 border border-[#e11f3a] flex items-center justify-center">
            <Lock className="w-4 h-4 text-[#e11f3a]" />
          </span>
          <h1 className="text-xl tracking-[0.22em] uppercase font-normal">Admin</h1>
        </div>
        <p className="mt-2 text-[11px] tracking-[0.25em] uppercase text-neutral-500">Backoffice dashboard</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6">
          <div>
            <label className="block text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-2">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputCls}
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-2">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-[#e11f3a]">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-black text-white py-3 text-sm tracking-[0.3em] uppercase hover:bg-[#e11f3a] transition-colors disabled:opacity-60"
          >
            {loading ? '...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
